import { Injectable, Injector } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class XlsxService {

  constructor(private _injector: Injector) { }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  public export(exportData: any, fileName: string) {
    if (exportData) {
      // const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData[0].Data);
      // const workbook: XLSX.WorkBook = {
      //     Sheets: { 'data': worksheet },
      //     SheetNames: ['data']
      // };
      var wb = XLSX.utils.book_new();
      exportData.forEach((element: { Data: any; Title: string }) => {
        var ws = XLSX.utils.json_to_sheet(element.Data, { skipHeader: false });
        XLSX.utils.book_append_sheet(wb, ws, element.Title);
      });
      const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, fileName);
    }
  }
  // Added by Manas Bej on 2021-09-29 for exporting multiple sheets in excel
  // Its a optized version of export method
  public exportToExcel(exportData: any[], fileName: string): void {
    if (!exportData || exportData.length === 0) {
      console.error('No data available to export.');
      return;
    }
  
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
  
    exportData.forEach((element: { Data: any; Title: string }) => {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(element.Data, { skipHeader: false });
      XLSX.utils.book_append_sheet(workbook, worksheet, element.Title || 'Sheet1');
    });
  
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }
}
